
import React, { useEffect, useState } from 'react';
import './App.css';
import Login from './components/Login/Login';
import Footer from './components/Footer/Footer';
import Menu from './components/Menu/Menu';
import OrderLists from './components/OrderLists/OrderLists';
import { db, auth } from './firebase';
import { doc, setDoc, increment, onSnapshot, serverTimestamp, addDoc, collection, query, orderBy, getDocs, deleteDoc, runTransaction } from 'firebase/firestore';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import MicrowaveTwoTone from '@mui/icons-material/MicrowaveTwoTone';
import CountertopsTwoTone from '@mui/icons-material/CountertopsTwoTone';
import ShoppingCartTwoTone from '@mui/icons-material/ShoppingCartTwoTone';
import GirlIcon from '@mui/icons-material/Girl';
import WomanIcon from '@mui/icons-material/Woman';

function App() {
  const [user, setUser] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);
  const [view, setView] = useState('main');
  const [dishwasherLoading, setDishwasherLoading] = useState(false);
  const [dishwasherMsg, setDishwasherMsg] = useState(null);
  const [dishwasherCounts, setDishwasherCounts] = useState({ user1: 0, user2: 0 });
  const [dishwasherLastClicked, setDishwasherLastClicked] = useState(null);
  const [lastAction, setLastAction] = useState(null); // { inverse: {user1: n, user2: m}, timeoutId }
  const [dryerCounts, setDryerCounts] = useState({ user1: 0, user2: 0 });
  const [dryerLastClicked, setDryerLastClicked] = useState(null);
  const [kitchenCounts, setKitchenCounts] = useState({ user1: 0, user2: 0 });
  const [kitchenLastClicked, setKitchenLastClicked] = useState(null);
  const [washCounts, setWashCounts] = useState({ user1: 0, user2: 0 });
  const [washLastClicked, setWashLastClicked] = useState(null);
  const [dryerLoading, setDryerLoading] = useState(false);
  const [kitchenLoading, setKitchenLoading] = useState(false);
  const [washLoading, setWashLoading] = useState(false);
  const [dryerMsg, setDryerMsg] = useState(null);
  const [kitchenMsg, setKitchenMsg] = useState(null);
  const [washMsg, setWashMsg] = useState(null);
  const [lastActionByDevice, setLastActionByDevice] = useState({});
  const [events, setEvents] = useState([]);
  const [deletingEvents, setDeletingEvents] = useState({});

  // Define the two users
  const USER1_EMAIL = 'kolkalena@icloud.com';
  const USER2_EMAIL = 'tosiahanna135@gmail.com';

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (u) => {
      setUser(u);
      // mark that we've received the initial auth state from Firebase
      setAuthChecked(true);
    });
    return () => unsubscribe();
  }, []);

  // Helpers: format timestamp (ms) and check remaining lock
  const formatTime = (ms) => {
    if (!ms) return 'Never';
    try { return new Date(ms).toLocaleString(); } catch (e) { return String(ms); }
  };

  const isLocked = (ms) => {
    if (!ms) return false;
    return (Date.now() - ms) < 5000; // locked for 60s
  };

  // tick every second so countdown badges update
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const remainingSeconds = (ms) => {
    if (!ms) return 0;
    const rem = Math.ceil((5000 - (now - ms)) / 1000);
    return rem > 0 ? rem : 0;
  };

  const displayEmail = (email) => {
    if (!email) return '';
    const atIndex = email.indexOf('@');
    return atIndex === -1 ? email : email.slice(0, atIndex);
  };

  // Helper to display user short form: 'O' for USER1, 'T' for USER2, fallback to first char of local-part
  const userShort = (email) => {
    if (!email) return '';
    if (email === USER1_EMAIL) return 'O';
    if (email === USER2_EMAIL) return 'T';
    const local = email.split('@')[0];
    return local ? local.charAt(0).toUpperCase() : '';
  };

  // Subscribe to dishwasher doc real-time updates
  useEffect(() => {
    const docRef = doc(db, 'devices', 'dishwasher');
    const unsub = onSnapshot(docRef, (snap) => {
      if (!snap.exists()) {
        setDishwasherCounts({ user1: 0, user2: 0 });
        setDishwasherLastClicked(null);
        return;
      }
      const data = snap.data();
      setDishwasherCounts({ user1: Number(data.user1 || 0), user2: Number(data.user2 || 0) });
      // derive last-click from user1Time / user2Time fields (Firestore Timestamp)
      const u1 = data.user1Time ? (typeof data.user1Time.toMillis === 'function' ? data.user1Time.toMillis() : new Date(data.user1Time).getTime()) : 0;
      const u2 = data.user2Time ? (typeof data.user2Time.toMillis === 'function' ? data.user2Time.toMillis() : new Date(data.user2Time).getTime()) : 0;
      const last = Math.max(u1 || 0, u2 || 0) || null;
      setDishwasherLastClicked(last);
    }, (err) => {
      console.error('dishwasher onSnapshot error', err);
    });
    return () => unsub();
  }, []);

  // Subscribe to other device docs
  useEffect(() => {
  const dryerRef = doc(db, 'devices', 'dryer');
  const kitchenRef = doc(db, 'devices', 'kitchen');
  const washRef = doc(db, 'devices', 'trash');

    const unsubDryer = onSnapshot(dryerRef, (snap) => {
      if (!snap.exists()) { setDryerCounts({ user1: 0, user2: 0 }); setDryerLastClicked(null); return; }
      const d = snap.data(); setDryerCounts({ user1: Number(d.user1 || 0), user2: Number(d.user2 || 0) });
      const u1 = d.user1Time ? (typeof d.user1Time.toMillis === 'function' ? d.user1Time.toMillis() : new Date(d.user1Time).getTime()) : 0;
      const u2 = d.user2Time ? (typeof d.user2Time.toMillis === 'function' ? d.user2Time.toMillis() : new Date(d.user2Time).getTime()) : 0;
      setDryerLastClicked(Math.max(u1||0, u2||0) || null);
    }, (err) => console.error('dryer onSnapshot error', err));

    const unsubKitchen = onSnapshot(kitchenRef, (snap) => {
      if (!snap.exists()) { setKitchenCounts({ user1: 0, user2: 0 }); setKitchenLastClicked(null); return; }
      const d = snap.data(); setKitchenCounts({ user1: Number(d.user1 || 0), user2: Number(d.user2 || 0) });
      const u1 = d.user1Time ? (typeof d.user1Time.toMillis === 'function' ? d.user1Time.toMillis() : new Date(d.user1Time).getTime()) : 0;
      const u2 = d.user2Time ? (typeof d.user2Time.toMillis === 'function' ? d.user2Time.toMillis() : new Date(d.user2Time).getTime()) : 0;
      setKitchenLastClicked(Math.max(u1||0, u2||0) || null);
    }, (err) => console.error('kitchen onSnapshot error', err));

    const unsubWash = onSnapshot(washRef, (snap) => {
      if (!snap.exists()) { setWashCounts({ user1: 0, user2: 0 }); setWashLastClicked(null); return; }
      const d = snap.data(); setWashCounts({ user1: Number(d.user1 || 0), user2: Number(d.user2 || 0) });
      const u1 = d.user1Time ? (typeof d.user1Time.toMillis === 'function' ? d.user1Time.toMillis() : new Date(d.user1Time).getTime()) : 0;
      const u2 = d.user2Time ? (typeof d.user2Time.toMillis === 'function' ? d.user2Time.toMillis() : new Date(d.user2Time).getTime()) : 0;
      setWashLastClicked(Math.max(u1||0, u2||0) || null);
  }, (err) => console.error('trash onSnapshot error', err));

    return () => { unsubDryer(); unsubKitchen(); unsubWash(); };
  }, []);

  // Subscribe to events collection (newest first)
  useEffect(() => {
    const eventsRef = collection(db, 'events');
    const q = query(eventsRef, orderBy('datetime', 'desc'));
    const unsub = onSnapshot(q, (snap) => {
      const items = snap.docs.map(d => {
        const data = d.data();
        const ms = data.datetime ? (typeof data.datetime.toMillis === 'function' ? data.datetime.toMillis() : new Date(data.datetime).getTime()) : null;
        return { id: d.id, device: data.device, user: data.user, datetimeMs: ms };
      });
      setEvents(items);
    }, (err) => console.error('events onSnapshot error', err));
    return () => unsub();
  }, []);
  const addEvent = async (deviceName, userEmail) => {
    try {
      await addDoc(collection(db, 'events'), { datetime: serverTimestamp(), device: deviceName, user: userEmail });
      // prune if more than 30
      const allSnap = await getDocs(query(collection(db, 'events'), orderBy('datetime', 'asc')));
      const total = allSnap.size;
      if (total > 30) {
        const excess = total - 30;
        const docsToDelete = allSnap.docs.slice(0, excess);
        for (const d of docsToDelete) {
          try {
            await deleteDoc(doc(db, 'events', d.id));
          } catch (e) {
            console.warn('Failed to delete old event', d.id, e);
          }
        }
      }
    } catch (e) {
      console.error('addEvent error', e);
      throw e;
    }
  };

  // Delete an event (only allowed for the event owner). When deleting, apply
  // the points change as if the opposite user had clicked "Erledigt".
  const handleDeleteEvent = async (ev) => {
    if (!user) return;
    if (ev.user !== user.email) return;
    setDeletingEvents(prev => ({ ...prev, [ev.id]: true }));
    const eventRef = doc(db, 'events', ev.id);
    const deviceRef = doc(db, 'devices', ev.device);
    try {
      await runTransaction(db, async (t) => {
        // Read current device counts
        const snap = await t.get(deviceRef);
        const cur = snap.exists() ? snap.data() : {};
        const cur1 = Number(cur.user1 || 0);
        const cur2 = Number(cur.user2 || 0);

        // Determine original actor and opposite actor
        const originalIsUser1 = ev.user === USER1_EMAIL;
        const actorIsUser1 = !originalIsUser1; // opposite actor

        let new1 = cur1;
        let new2 = cur2;
        if (actorIsUser1) {
          if (cur2 <= 1) new1 = cur1 + 1;
          new2 = cur2 - 1;
        } else {
          if (cur1 <= 1) new2 = cur2 + 1;
          new1 = cur1 - 1;
        }
        if (new1 < 0) new1 = 0;
        if (new2 < 0) new2 = 0;

        const toSet = actorIsUser1
          ? { user1: new1, user2: new2, user1Time: serverTimestamp() }
          : { user1: new1, user2: new2, user2Time: serverTimestamp() };

        t.set(deviceRef, toSet, { merge: true });
        // delete the event doc
        t.delete(eventRef);
      });
    } catch (e) {
      console.error('Failed to delete event & update counts', e);
      // optional: show a user-facing message
    } finally {
      setDeletingEvents(prev => { const copy = { ...prev }; delete copy[ev.id]; return copy; });
    }
  };

  // Shared transactional rule for all devices.
  // If actorIsUser1: if (PointsUser2 <= 1) PointsUser1++; PointsUser2--
  // else: if (PointsUser1 <= 1) PointsUser2++; PointsUser1--
  // Then clamp negatives. Returns { delta1, delta2, docRef } where delta1 = new1 - old1
  const applyClickToDevice = async (deviceId, actorIsUser1) => {
    const docRef = doc(db, 'devices', deviceId);
    const res = await runTransaction(db, async (t) => {
      const snap = await t.get(docRef);
      const cur = snap.exists() ? snap.data() : {};
      const cur1 = Number(cur.user1 || 0);
      const cur2 = Number(cur.user2 || 0);
      let new1 = cur1;
      let new2 = cur2;

      if (actorIsUser1) {
        if (cur2 <= 1) new1 = cur1 + 1;
        new2 = cur2 - 1;
      } else {
        if (cur1 <= 1) new2 = cur2 + 1;
        new1 = cur1 - 1;
      }

      if (new1 < 0) new1 = 0;
      if (new2 < 0) new2 = 0;

      const toSet = actorIsUser1
        ? { user1: new1, user2: new2, user1Time: serverTimestamp() }
        : { user1: new1, user2: new2, user2Time: serverTimestamp() };

      t.set(docRef, toSet, { merge: true });
      return { delta1: new1 - cur1, delta2: new2 - cur2, docRef };
    });
    return res;
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (err) {
      // Optionally show an error to the user
      console.error('Sign out error', err);
    }
  };

  // While Firebase hasn't returned the initial auth state, show a loading/skeleton
  if (!authChecked) {
    return (
      <div className="App">
        <header className="App-header">
          <div className="app-shell-width">
            <div className="header-left">
              <button className="hamburger" aria-label="Open menu">☰</button>
              {view === 'orderlists' ? (
                <button
                  className="nav-icon-btn"
                  onClick={() => setView('main')}
                  aria-label="Scores"
                  title="Scores"
                >
                  <GirlIcon fontSize="small" style={{ transform: 'rotate(7deg)' }} />
                  <span className="nav-icon-text">vs</span>
                  <WomanIcon fontSize="small" style={{ transform: 'rotate(-9deg)' }} />
                </button>
              ) : (
                <button
                  className="nav-icon-btn"
                  onClick={() => setView('orderlists')}
                  aria-label="Einkaufsliste"
                  title="Einkaufsliste"
                >
                  <ShoppingCartTwoTone fontSize="small" />
                </button>
              )}
            </div>
            <div className="header-right">
              <div className="auth-info"><span className="auth-email">&nbsp;</span></div>
              <button className={`auth-btn logged-out`} aria-hidden="true">🔴</button>
            </div>
          </div>
        </header>
        <main>
          <div style={{padding: '2rem', textAlign: 'center'}}>Loading…</div>
        </main>
        <Footer user={null} onLogout={() => {}} />
      </div>
    );
  }

  return (
    <div className="App">
    <header className="App-header">
      <div className="app-shell-width">
        <div className="header-left">
          <Menu onSelect={(v) => setView(v)} />
          {view === 'orderlists' ? (
            <button
              className="nav-icon-btn"
              onClick={() => setView('main')}
              aria-label="Scores"
              title="Scores"
            >
              <GirlIcon fontSize="small" style={{ transform: 'rotate(7deg)' }} />
              <span className="nav-icon-text">vs</span>
              <WomanIcon fontSize="small" style={{ transform: 'rotate(-9deg)' }} />
            </button>
          ) : (
            <button
              className="nav-icon-btn"
              onClick={() => setView('orderlists')}
              aria-label="Einkaufsliste"
              title="Einkaufsliste"
            >
              <ShoppingCartTwoTone fontSize="small" />
            </button>
          )}
        </div>
        <div className="header-right">
          <div className="auth-info">
            <span className="auth-email">{displayEmail(user ? user.email : '')}</span>
          </div>

          <button
            className={`auth-btn ${user ? 'logged-in' : 'logged-out'}`}
            onClick={user ? handleLogout : () => document.getElementById('email')?.focus()}
            title={user ? 'Logout' : 'Go to login'}
            aria-label={user ? 'Logout' : 'Login'}
          >
            {user ? '🟢' : '🔴'}
          </button>
        </div>
      </div>
    </header>

      <main>
        {user ? (
          view === 'orderlists' ? (
            <OrderLists />
          ) : (
          <div className="main-content">
            <table className="device-table" role="table" aria-label="Devices">
              <thead>
                <tr className="device-header">
                  <th>Do it</th>
                  <th>Check</th>
                  <th>O</th>
                  <th>T</th>
                </tr>
              </thead>
              <tbody>
                <tr className="device-row">
                  {/* Do it column */}
                  <td>
                    <button
                      className="erledigt-btn"
                      onClick={async () => {
                        setDishwasherMsg(null);
                        if (!user) {
                          setDishwasherMsg('Please log in to mark as done.');
                          return;
                        }
                        // enforce 1 minute lock
                        if (dishwasherLastClicked && (Date.now() - dishwasherLastClicked) < 5000) {
                          setDishwasherMsg('Locked — please wait before marking again.');
                          return;
                        }
                        setDishwasherLoading(true);
                        try {
                          const docRef = doc(db, 'devices', 'dishwasher');
                          if (user.email === USER1_EMAIL || user.email === USER2_EMAIL) {
                            const isUser1 = user.email === USER1_EMAIL;
                            const deltas = await applyClickToDevice('dishwasher', isUser1);
                            setDishwasherLastClicked(Date.now());
                            try { await addEvent('dishwasher', user.email); } catch (e) { console.error('log event failed', e); }
                            const inverse = { user1: -deltas.delta1, user2: -deltas.delta2 };
                            const timeoutId = setTimeout(() => setLastActionByDevice(prev => { const copy={...prev}; delete copy.dishwasher; return copy; }), 8000);
                            setLastActionByDevice(prev => ({ ...prev, dishwasher: { inverse, timeoutId, docRef } }));
                          } else {
                            setDishwasherMsg('Your account is not authorized for this action.');
                          }
                        } catch (err) {
                          console.error('Firestore update error', err);
                          setDishwasherMsg('Failed to update dishwasher counts.');
                        } finally {
                          setDishwasherLoading(false);
                        }
                      }}
                      disabled={dishwasherLoading || isLocked(dishwasherLastClicked)}
                    >
                      {dishwasherLoading ? '…' : 'Erledigt'}
                      {isLocked(dishwasherLastClicked) && (
                        <span className="lock-badge">{remainingSeconds(dishwasherLastClicked)}s</span>
                      )}
                    </button>
                  </td>

                  {/* Check column: icon + label */}
                  <td className="device-check">
                    <MicrowaveTwoTone className="device-icon" aria-hidden="true" fontSize="large" style={{ transform: 'rotate(-90deg)' }} />
                  </td>

                  {/* O column: user1 counter */}
                  <td className="counter-col">
                    <span className={`counter user1 ${dishwasherCounts.user1 >= 1 ? 'positive' : 'negative'}`}>
                      {dishwasherCounts.user1}
                    </span>
                  </td>

                  {/* T column: user2 counter */}
                  <td className="counter-col">
                    <div>
                      <span className={`counter user2 ${dishwasherCounts.user2 >= 1 ? 'positive' : 'negative'}`}>
                        {dishwasherCounts.user2}
                      </span>
                    </div>
                  </td>

                  
                </tr>

                {/* Other device rows: Dryer, Kitchen, Trash */}
                <tr className="device-row">
                  <td>
                    <button
                      className="erledigt-btn"
                      onClick={async () => {
                        setDryerMsg(null);
                        if (!user) { setDryerMsg('Please log in to mark as done.'); return; }
                        if (dryerLastClicked && (Date.now() - dryerLastClicked) < 5000) { setDryerMsg('Locked — please wait before marking again.'); return; }
                        setDryerLoading(true);
                        try {
                          const docRef = doc(db, 'devices', 'dryer');
                          if (user.email === USER1_EMAIL || user.email === USER2_EMAIL) {
                            const isUser1 = user.email === USER1_EMAIL;
                            const deltas = await applyClickToDevice('dryer', isUser1);
                            setDryerLastClicked(Date.now());
                            try { await addEvent('dryer', user.email); } catch (e) { console.error('log event failed', e); }
                            const inverse = { user1: -deltas.delta1, user2: -deltas.delta2 };
                            const timeoutId = setTimeout(() => setLastActionByDevice(prev => { const copy={...prev}; delete copy.dryer; return copy; }), 8000);
                            setLastActionByDevice(prev => ({ ...prev, dryer: { inverse, timeoutId, docRef } }));
                          } else {
                            setDryerMsg('Your account is not authorized for this action.');
                          }
                        } catch (err) {
                          console.error('Firestore update error', err);
                          setDryerMsg('Failed to update dryer counts.');
                        } finally {
                          setDryerLoading(false);
                        }
                      }}
                      disabled={dryerLoading || isLocked(dryerLastClicked)}
                    >
                      {dryerLoading ? '…' : 'Erledigt'}
                      {isLocked(dryerLastClicked) && (
                        <span className="lock-badge">{remainingSeconds(dryerLastClicked)}s</span>
                      )}
                    </button>
                  </td>
                  <td className="device-check"><span className="device-icon">🌀</span></td>
                  <td className="counter-col"><span className={`counter user1 ${dryerCounts.user1 >= 1 ? 'positive' : 'negative'}`}>{dryerCounts.user1}</span></td>
                  <td className="counter-col"><span className={`counter user2 ${dryerCounts.user2 >= 1 ? 'positive' : 'negative'}`}>{dryerCounts.user2}</span></td>
                  
                </tr>

                <tr className="device-row">
                  <td>
                    <button
                      className="erledigt-btn"
                      onClick={async () => {
                        setKitchenMsg(null);
                        if (!user) { setKitchenMsg('Please log in to mark as done.'); return; }
                        if (kitchenLastClicked && (Date.now() - kitchenLastClicked) < 5000) { setKitchenMsg('Locked — please wait before marking again.'); return; }
                        setKitchenLoading(true);
                        try {
                          const docRef = doc(db, 'devices', 'kitchen');
                          if (user.email === USER1_EMAIL || user.email === USER2_EMAIL) {
                            const isUser1 = user.email === USER1_EMAIL;
                            const deltas = await applyClickToDevice('kitchen', isUser1);
                            setKitchenLastClicked(Date.now());
                            try { await addEvent('kitchen', user.email); } catch (e) { console.error('log event failed', e); }
                            const inverse = { user1: -deltas.delta1, user2: -deltas.delta2 };
                            const timeoutId = setTimeout(() => setLastActionByDevice(prev => { const copy={...prev}; delete copy.kitchen; return copy; }), 8000);
                            setLastActionByDevice(prev => ({ ...prev, kitchen: { inverse, timeoutId, docRef } }));
                          } else {
                            setKitchenMsg('Your account is not authorized for this action.');
                          }
                        } catch (err) {
                          console.error('Firestore update error', err);
                          setKitchenMsg('Failed to update kitchen counts.');
                        } finally {
                          setKitchenLoading(false);
                        }
                      }}
                      disabled={kitchenLoading || isLocked(kitchenLastClicked)}
                    >
                      {kitchenLoading ? '…' : 'Erledigt'}
                      {isLocked(kitchenLastClicked) && (
                        <span className="lock-badge">{remainingSeconds(kitchenLastClicked)}s</span>
                      )}
                    </button>
                  </td>
                  <td className="device-check"><CountertopsTwoTone className="device-icon" aria-hidden="true" fontSize="large" /></td>
                  <td className="counter-col"><span className={`counter user1 ${kitchenCounts.user1 >= 1 ? 'positive' : 'negative'}`}>{kitchenCounts.user1}</span></td>
                  <td className="counter-col"><span className={`counter user2 ${kitchenCounts.user2 >= 1 ? 'positive' : 'negative'}`}>{kitchenCounts.user2}</span></td>
                  
                </tr>

                <tr className="device-row">
                  <td>
                    <button
                      className="erledigt-btn"
                      onClick={async () => {
                        setWashMsg(null);
                        if (!user) { setWashMsg('Please log in to mark as done.'); return; }
                        if (washLastClicked && (Date.now() - washLastClicked) < 5000) { setWashMsg('Locked — please wait before marking again.'); return; }
                        setWashLoading(true);
                        try {
                          const docRef = doc(db, 'devices', 'trash');
                          if (user.email === USER1_EMAIL || user.email === USER2_EMAIL) {
                            const isUser1 = user.email === USER1_EMAIL;
                            const deltas = await applyClickToDevice('trash', isUser1);
                            setWashLastClicked(Date.now());
                            try { await addEvent('trash', user.email); } catch (e) { console.error('log event failed', e); }
                            const inverse = { user1: -deltas.delta1, user2: -deltas.delta2 };
                            const timeoutId = setTimeout(() => setLastActionByDevice(prev => { const copy={...prev}; delete copy.trash; return copy; }), 8000);
                            setLastActionByDevice(prev => ({ ...prev, trash: { inverse, timeoutId, docRef } }));
                          } else {
                            setWashMsg('Your account is not authorized for this action.');
                          }
                        } catch (err) {
                          console.error('Firestore update error', err);
                          setWashMsg('Failed to update washing machine counts.');
                        } finally {
                          setWashLoading(false);
                        }
                      }}
                      disabled={washLoading || isLocked(washLastClicked)}
                    >
                      {washLoading ? '…' : 'Erledigt'}
                      {isLocked(washLastClicked) && (
                        <span className="lock-badge">{remainingSeconds(washLastClicked)}s</span>
                      )}
                    </button>
                  </td>
                  <td className="device-check"><span className="device-icon">🗑️</span></td>
                  <td className="counter-col"><span className={`counter user1 ${washCounts.user1 >= 1 ? 'positive' : 'negative'}`}>{washCounts.user1}</span></td>
                  <td className="counter-col"><span className={`counter user2 ${washCounts.user2 >= 1 ? 'positive' : 'negative'}`}>{washCounts.user2}</span></td>
                  
                </tr>
              </tbody>
            </table>

            <section className="events-section">
              <h2>Events</h2>

              {/* Prepare events per device */}
              {/** events is newest-first; keep that order per subtable */}
              {(() => {
                const byDevice = {
                  dishwasher: events.filter(e => e.device === 'dishwasher'),
                  dryer: events.filter(e => e.device === 'dryer'),
                  kitchen: events.filter(e => e.device === 'kitchen'),
                  trash: events.filter(e => e.device === 'trash'),
                };

                const deviceIcon = {
                  dishwasher: <MicrowaveTwoTone aria-hidden="true" fontSize="large" style={{ transform: 'rotate(-90deg)' }} />,
                  dryer: '🌀',
                  kitchen: <CountertopsTwoTone aria-hidden="true" fontSize="large" />,
                  trash: '🗑️',
                };

                const deviceOrder = ['dishwasher','dryer','kitchen','trash'];

                return (
                  <div className="events-row" role="region" aria-label="Device events">
                    {deviceOrder.map(dev => (
                      <div className="events-sub" key={dev}>
                        <table className="events-subtable" role="table" aria-label={`${dev} events`}>
                          <tbody>
                            {byDevice[dev].map(ev => (
                              <tr key={ev.id}>
                                <td>{formatTime(ev.datetimeMs)}</td>
                                <td title={dev} style={{textAlign:'center'}}>{deviceIcon[dev]}</td>
                                <td style={{textAlign:'center'}}>{userShort(ev.user)}</td>
                                <td style={{textAlign:'center'}}>
                                  {user && ev.user === user.email ? (
                                    <button
                                      className="delete-event-btn"
                                      onClick={async () => {
                                        try {
                                          await handleDeleteEvent(ev);
                                        } catch (e) {
                                          console.error('delete handler error', e);
                                        }
                                      }}
                                      disabled={!!deletingEvents[ev.id]}
                                      aria-label="Delete event"
                                      title="Delete event"
                                    >
                                      {deletingEvents[ev.id] ? '…' : '✖'}
                                    </button>
                                  ) : null}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ))}
                  </div>
                );
              })()}
            </section>
          </div>
          )
        ) : (
          <Login />
        )}
      </main>

      {/* Footer shows signed-in info and logout button */}
      <Footer user={user} onLogout={handleLogout} />
    </div>
  );
}

export default App;
